export default value => !!value.match(/^[ A-Za-z_-\s]*$/i);